import { createContext, useContext, useState } from "react";

const SwipeContext = createContext();

export function SwipeProvider({ children }) {
	const [openId, setOpenId] = useState(null);

	return (
		<SwipeContext.Provider value={{ openId, setOpenId }}>
			{children}
		</SwipeContext.Provider>
	);
}

export function useSwipe() {
	return useContext(SwipeContext);
}